import styled from '@emotion/styled';
import { Button, DialogActions, DialogTitle, Typography } from '@material-ui/core';
import { createElement, FC, useState } from 'react';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';

import theme from '../../../../theme';
import { SPACING_UNIT } from '../../../constant/spacing';
import Dialog from '../../primitive/DialogWithPadding';
import BatchDownloadButton from './BatchDownloadButton';

interface Props {
  open: boolean;
  onRequestClose: () => void;
  onClickCancelButton: () => void;
  onClick: () => void;
  className?: string;
}

const ConfirmationDialog: FC<Props> = ({ open, onRequestClose, onClickCancelButton, onClick, className }) => {
  const [downloadLoading, setLoading] = useState(false);

  return (
    <Dialog open={open} onRequestClose={onRequestClose} className={className}>
      <DialogTitle disableTypography>
        <Typography variant="h6">
          <FormattedMessage id="show_project_page.actions.download_all" />
        </Typography>
        <Typography color="textSecondary">
          <FormattedHTMLMessage id="show_project_page.actions.dialog.description" />
        </Typography>
      </DialogTitle>

      <StyledDialogActions>
        <Button
          color="default"
          onClick={() => {
            onClickCancelButton();
          }}
        >
          <FormattedMessage id="show_project_page.actions.dialog.cancel" />
        </Button>

        <BatchDownloadButton
          label="show_project_page.actions.dialog.download_all"
          onClick={async () => {
            setLoading(true);
            await onClick();
            setTimeout(() => {
              setLoading(false);
            }, 30 * 1000);
          }}
          disabled={downloadLoading}
        />
      </StyledDialogActions>
    </Dialog>
  );
};

const StyledDialogActions = styled(DialogActions)({
  borderTop: `1px solid ${theme.palette.grey['200']}`,
  marginTop: 0,
  paddingTop: SPACING_UNIT * 2,
  paddingBottom: SPACING_UNIT,
  height: 60,
});

export default ConfirmationDialog;
